import _ from 'lodash'

export const updateFundAllocation = (fundAllocations, changedFund) => {
  const fundAllocationsByCode = _.keyBy(fundAllocations, 'code')
  fundAllocationsByCode[changedFund.code] = {
    ...fundAllocationsByCode[changedFund.code],
    fundAllocation: changedFund.fundAllocation,
  }
  return _.values(fundAllocationsByCode)
}
